import LTR from "@brand-icons/ploom/ui-target/ui-target-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiTargetIcon = iconFactory("UiTargetIcon", LTR);
